export function parsePercentageToInt(percentage: string): number {
  // Remove the '%' sign and replace comma with dot for decimal parsing
  const normalized = percentage.trim().replace('%', '').replace(',', '.');
  const value = parseFloat(normalized);

  if (isNaN(value)) {
    throw new Error(`Invalid percentage format: "${percentage}"`);
  }

  return Math.round(value);
}
